import { render, staticRenderFns } from "./CollectionOperations.vue?vue&type=template&id=c89ffec2"
import script from "./CollectionOperations.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionOperations.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports